<template>
    <LockDesignerPanel @update-route="handleUpdateRoute" @update-selection="handleUpdateSelection"></LockDesignerPanel>
</template>
<script lang="ts">
import LockDesignerPanel from 'Vue/components/lockDesigner/components/LockDesignerPanel.vue';

import { mapGetters, mapActions } from 'vuex'; // Import useStore from vuex

export default {
    name: 'LockDesignerProducts',
    components: {
        LockDesignerPanel,
    },
    computed: {
        ...mapActions(['fetchProduct', 'fetchUpdatedProducts']),
        ...mapGetters(['componentGroups', 'resetComponentGroups', 'isLoadingDefault', 'filters']),
        productType: function () {
            return this.$route.params?.product;
        },
    },
    emits: ['update-route'],

    methods: {
        handleUpdateRoute(route: any) {
            this.$emit('update-route', route);
        },

        async handleUpdateSelection (selection) {
            let updatedSelection = selection;
            await this.$store.dispatch('fetchUpdatedProducts', { productType: this.productType, ...updatedSelection });
        },

        async handleFetchPageData() {
            await this.$store.dispatch('fetchProduct', { productType: this.productType, filters: this.filters });
        },
    },
    mounted() {
        if (!this.isLoadingDefault) {
            this.handleFetchPageData();
        }
    },
    unmounted() {
        this.$store.dispatch('resetComponentGroups');
    },
};
</script>
